
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp",
      function () {
        return require("private-next-pages/whatsapp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp"])
      });
    }
  